import React from 'react';
import PropTypes from 'prop-types';
import { pagerActionTypes, compStatusTypes } from '../../Constants';
import BaseComponent from './BaseComponent';

class Pager extends BaseComponent {
    createPrevButton() {
        return (
            <div className="pagerButtonView">
                <span
                    className={`prevButton pagerButton ${
                        this.props.prevStatus
                    }`}
                    onClick={() => {
                        if (this.props.prevStatus === compStatusTypes.ENABLED) {
                            this.props.onPagerClick(pagerActionTypes.PREV);
                        }
                    }}
                />
            </div>
        );
    }

    createNextButton() {
        return (
            <div className="pagerButtonView">
                <span
                    className={`nextButton pagerButton ${
                        this.props.nextStatus
                    }`}
                    onClick={() => {
                        if (this.props.nextStatus === compStatusTypes.ENABLED) {
                            this.props.onPagerClick(pagerActionTypes.NEXT);
                        }
                    }}
                />
            </div>
        );
    }

    render() {
        return (
            <div className="pagerView">
                {this.createPrevButton()}
                <div className="pagerContent">{this.props.children}</div>
                {this.createNextButton()}
            </div>
        );
    }
}

Pager.displayName = 'Pager';
Pager.propTypes = {
    prevStatus: PropTypes.oneOf(Object.keys(compStatusTypes)),
    nextStatus: PropTypes.oneOf(Object.keys(compStatusTypes)),
    onPagerClick: PropTypes.func.isRequired,
};

export default Pager;



// WEBPACK FOOTER //
// ./components/CommonSet/Pager.js